import React, { useState, useCallback, useContext, createContext } from 'react';

// ─── 基础 Modal ─────────────────────────────────────────────────────────────
export default function Modal({ show, onClose, title, children }) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        {title && <h3>{title}</h3>}
        {children}
      </div>
    </div>
  );
}

// ─── ConfirmModal：统一确认弹窗，替代 window.confirm ───────────────────────
// 用法：
//   const confirm = useConfirm();
//   const ok = await confirm('确认删除？');
//   if (!ok) return;

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  // state: { message, detail, danger, resolve }

  const confirm = useCallback((message, { detail, danger } = {}) => {
    return new Promise(resolve => {
      setState({ message, detail, danger, resolve });
    });
  }, []);

  const handleConfirm = () => {
    state?.resolve(true);
    setState(null);
  };
  const handleCancel = () => {
    state?.resolve(false);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: '0 24px',
          }}
          onClick={handleCancel}
        >
          <div
            style={{
              background: 'var(--c-surface)', borderRadius: 18, padding: '24px 20px 20px',
              width: '100%', maxWidth: 360, boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--c-text)', marginBottom: state.detail ? 8 : 20, lineHeight: 1.4 }}>
              {state.message}
            </div>
            {state.detail && (
              <div style={{ fontSize: 13, color: 'var(--c-text-secondary)', marginBottom: 20, lineHeight: 1.6 }}>
                {state.detail}
              </div>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={handleCancel}
                style={{
                  flex: 1, height: 44, borderRadius: 12, fontSize: 15, fontWeight: 600,
                  background: 'var(--c-bg)', color: 'var(--c-text)',
                  border: '1px solid var(--c-border)', cursor: 'pointer',
                }}
              >
                取消
              </button>
              <button
                onClick={handleConfirm}
                style={{
                  flex: 1, height: 44, borderRadius: 12, fontSize: 15, fontWeight: 600,
                  background: state.danger ? 'var(--c-danger)' : 'var(--c-primary)',
                  color: 'white', border: 'none', cursor: 'pointer',
                }}
              >
                确认
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider');
  return ctx;
}
